import { createRoute } from '@tanstack/react-router'
import { guestLayoutRoute } from 'src/layouts/routes'

export const orderGuestRoute = createRoute({
  getParentRoute: () => guestLayoutRoute,
  path: '/order-guest'
})
